import { createContext } from "react";
import { ThemeProps } from "../Themes/Themes";

export type ThemeValueProps = {
  theme?: ThemeProps;
  getTheme?: VoidFunction;
  isLoading?: boolean;
};

const themeContext = createContext<ThemeValueProps>({});

export default themeContext;
